/* eslint-disable max-classes-per-file */
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { A365Named } from '../base/a365Named';
import { ModelConstants } from '../model-constants';
import { IViolation } from '../base/annotation';
import { ActionConstants } from '../../constants/action-constants';
import { Constants } from '../../shared/shared-constants';

@Metamodel.model({
    name: 'Kql Metadata'
})
export class KqlScriptMetadata {

    @Metamodel.attribute({
        display: 'language',
        constraint: {
            required: true
        }
    })
    public language: string;
}

@Metamodel.model({
    name: 'KQL Script Connection Key'
})
export class KqlScriptConnectionKey {

    @Metamodel.attribute({
        display: 'poolName'
    })
    public poolName?: string;

    @Metamodel.attribute({
        display: 'databaseName'
    })
    public databaseName?: string;
}

@Metamodel.model({
    name: 'KQL Script Content'
})
export class KqlScriptContent {

    @Metamodel.attribute({
        display: 'query'
    })
    public query?: string;

    @Metamodel.attribute({
        display: 'metadata'
    })
    public metadata?: KqlScriptMetadata;

    @Metamodel.attribute({
        display: 'currentConnection'
    })
    public currentConnection?: KqlScriptConnectionKey;
}

@Metamodel.model({
    name: ModelConstants.kqlScript,
    display: [shellStringResources.SynapseKqlScripts],
    reusable: true,
    referable: true,
    validator: KqlScript.validate,
    constraints: {
        name: {
            required: true,
            pattern: Constants.artifactNameValidator,
            uniqueModelName: true
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.kqlScriptsWrite
        },
        deleteResource: {
            action: ActionConstants.kqlScriptsDelete
        }
    }
})
export class KqlScript extends A365Named {
    public readonly useShellFolder: boolean = true;

    @Metamodel.attribute({
        display: 'query'
    })
    public content?: KqlScriptContent;

    // eslint-disable-next-line
    @Metamodel.attribute({
        display: 'type'
    })
    public type?: string;

    public runQueryOnOpen?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);

        this.description = description || '';
        this.content = new KqlScriptContent();
        this.content.metadata = new KqlScriptMetadata();
        this.content.metadata.language = 'kql';
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validate(owner: any): IViolation[] | undefined {
        // Prevent users from publishing sql script before the functionality is ready.
        return owner && owner.named && owner.named.extension && owner.named.extension.dummy
            ? [{
                context: owner,
                message: () => shellStringResources.KqlScriptPublishUnsupported
            }]
            : undefined;
    }
}
